import { Container } from 'components/gruenland/atoms/container/Container';
import { ImageProps } from 'components/gruenland/atoms/image';
import Link from 'components/gruenland/atoms/link';
import { useResolvedLocalizedObject } from 'helpers/hooks/useResolvedLocalizedObject';

export interface PdfFileProps {
  file: ImageProps;
}

const PdfFile: React.FC<PdfFileProps> = ({ file }) => {
  const resolvedTitle = useResolvedLocalizedObject(file.title ?? '');
  return (
    file && (
      <Container>
        <Link variant="buttonSecondaryNegative" download link={file.media?.file as string} target="_blank">
          {resolvedTitle}
        </Link>
      </Container>
    )
  );
};

export default PdfFile;
